/** Focus the first listed control that still has a validation error. */
export function focusFirstError(
  errors: Record<string, string>,
  fieldOrder: string[],
): void {
  for (const id of fieldOrder) {
    if (!errors[id]) continue;
    const el = document.getElementById(id);
    if (el instanceof HTMLElement) {
      el.focus();
      return;
    }
  }
}
